export default __webpack_public_path__ + "static/media/banner-inicio-transbrasil3.1408fbbc.webp";